import {
  IconHome,
  IconCalendarPlus,
  IconHistory,
  IconBook,
  IconBaguette,
  IconStopwatch,
} from '@tabler/icons-react';
import { NavItem } from '../types/navigation';

export const navigationItems: NavItem[] = [
  {
    label: 'Dashboard',
    href: '/',
    icon: <IconHome size={18} />,
    description: 'Your meal planning hub'
  },
  {
    label: 'Plan meals',
    href: '/planning',
    icon: <IconCalendarPlus size={18} />,
    description: 'Create new meal plans'
  },
  {
    label: 'Meal history',
    href: '/meal-plans',
    icon: <IconHistory size={18} />,
    description: 'View past meal plans'
  },
  {
    label: 'Quick bites',
    href: '/quick-bites',
    icon: <IconStopwatch size={18} />,
    description: 'Fast recipes with what you have on hand'
  },
  {
    label: 'My cookbook',
    href: '/cookbook',
    icon: <IconBook size={18} />,
    description: 'Your recipe collection'
  },
  {
    label: 'My pantry',
    href: '/pantry',
    icon: <IconBaguette size={18} />,
    description: 'Track your ingredients'
  }
];
